import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import AuthReducer from "./auth";
import JobsReducer from "./jobs";
import VacancyReducer from "./vacancy";
import StageReducer from "./stages";
import StagesPosition from "./stagePositions";
import FormInputs from "./formInputs";
import Question from "./question";
import Rails from "./rails";
import VacancyAssociation from "./vacancyAssociation";
import Candidates from "./candidates";
import Messages from "./messages";
import Manager from "./manager";
import Documents from "./documents";
import Doubts from "./doubts";
import Employee from "./employee";
import Contracts from "./contracts";
import DynamicDashboard from "./dynamicdashboard";
import BankOfTalents from "./bankOfTalents";


const appReducer = history =>
  combineReducers({
    router: connectRouter(history),
    login: AuthReducer,
    jobs: JobsReducer,
    vaga: VacancyReducer,
    stages: StageReducer,
    stagesPosition: StagesPosition,
    formInputs: FormInputs,
    questions: Question,
    rails: Rails,
    vacancyAssociation: VacancyAssociation,
    candidates: Candidates,
    messages: Messages,
    profiles: Manager,
    documents: Documents,
    employee: Employee,
    contracts: Contracts,
    dynamicsdashboard: DynamicDashboard,
    bankOfTalents: BankOfTalents,
    doubts: Doubts,
  });
const Reducers = history => appReducer(history);

export default Reducers;
